<template>
	<v-dialog v-model="isOpen" max-width="500px" persistent>
		<v-card>
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">Review Details</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="close">
					<v-icon>close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-list two-line>
				<v-list-tile>
					<v-list-tile-avatar>
						<v-icon color="indigo">mdi-account</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title>{{ review.reviewedBy.fullName }}</v-list-tile-title>
						<v-list-tile-sub-title>Reviewed By</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-avatar>
						<v-icon color="indigo">mdi-calendar</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title>{{ review.reviewDateUTC | formatDate }}</v-list-tile-title>
						<v-list-tile-sub-title>Review Date</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

            <div v-if="review.notes" class="pa-4 text-xs-left">
				<div class="mb-2">
					<v-icon small class="mr-2" color="indigo">mdi-playlist-edit</v-icon>
					<h3 style="display: inline;">Notes</h3>
				</div>
				<div class="review-notes">{{ review.notes }}</div>
			</div>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="close">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			review: {
				type: Object,
				required: true
			},
			value: {
				type: Boolean,
				required: true
			}
		},
		computed: {
			isOpen: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit('input', val);
				}
			}
		},
		methods: {
			close() {
				this.isOpen = false;
			}
		}
	};
</script>

<style scoped>
	.review-notes {
	white-space: pre-wrap;
	line-height: 1.5;
	color: #444;
}
</style>
